/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Danish (Denmark)
export default {
  'project-contributors-picker.done': 'Færdig',
  'project-contributors-picker.go-back-label': 'Gå tilbage',
  'project-contributors-picker.header': 'Vælg medlemmer i projektet',
  'project-contributors-picker.your-teams-secondary-text':
    '{membersCount, plural, one {{membersCount,number} medlem} other {{membersCount,number} medlemmer}}',
  'project-contributors-picker.your-teams-secondary-text-focused':
    '{membersCount, plural, one {Vælg fra {membersCount,number} medlem} other {Vælg mellem {membersCount,number} medlemmer}}',
  'project-contributors-picker.your-teams-title': 'Dine teams',
  'project-fields.common.generic-error.description': 'Kontrollér din internetforbindelse, og prøv igen.',
  'project-fields.common.generic-error.title': 'Noget gik galt',
  'project-fields.link-item.delete-label': 'Slet',
  'project-fields.link-item.edit-label': 'Rediger',
  'project-fields.project-contributes-to.add-goal-title': 'Tilføj mål',
  'project-fields.project-contributes-to.empty-title': 'Ingen mål',
  'project-fields.project-contributes-to.title': 'Bidrager til',
  'project-fields.project-contributors.add-contributors-title': 'Tilføj bidragsydere',
  'project-fields.project-contributors.empty-title': 'Ingen bidragsydere',
  'project-fields.project-contributors.remove-contributor': 'Fjern bidragsyder',
  'project-fields.project-contributors.remove-contributor-error-message': 'Bidragsyderen kunne ikke fjernes',
  'project-fields.project-contributors.remove-team': 'Fjern team',
  'project-fields.project-contributors.show-more': 'Vis mere',
  'project-fields.project-contributors.title': 'Bidragsydere',
  'project-fields.project-contributors.view-profile': 'Vis profil',
  'project-fields.project-contributors.view-profile-team': 'Vis profil',
  'project-fields.project-focus-areas.title': 'Fokusområder',
  'project-fields.project-followers.add-followers-title': 'Tilføj følgere',
  'project-fields.project-followers.empty-title': 'Ingen følgere',
  'project-fields.project-followers.title': 'Følgere',
  'project-fields.project-link-picker.aria-label': 'Senest viste links',
  'project-fields.project-link-picker.invalid-link-input.error': 'Kontrollér, om linket er en gyldig webadresse.',
  'project-fields.project-link-picker.link-input.clear-label': 'Ryd link',
  'project-fields.project-link-picker.link-input.placeholder': 'Indsæt link, eller søg efter senest viste',
  'project-fields.project-link-picker.text-input.clear-label': 'Ryd tekst',
  'project-fields.project-link-picker.text-input.placeholder': 'Vist tekst (valgfrit)',
  'project-fields.project-links.add-links-title': 'Tilføj links',
  'project-fields.project-links.add-links-tooltip': 'Føj links til dokumenter, design og meget mere',
  'project-fields.project-links.delete-link-button': 'Slet link',
  'project-fields.project-links.edit-link-button': 'Rediger link',
  'project-fields.project-links.empty-title': 'Ingen links',
  'project-fields.project-links.title': 'Links',
  'project-fields.project-owner.title': 'Ejer',
  'project-fields.project-start-date.add-start-date-title': 'Tilføj startdato',
  'project-fields.project-start-date.cancel-button': 'Gem',
  'project-fields.project-start-date.creation-date': 'Dette projekt blev oprettet den {creationDate}',
  'project-fields.project-start-date.edit-start-date-label': 'Rediger projektets startdato',
  'project-fields.project-start-date.empty-title': 'Ingen startdato',
  'project-fields.project-start-date.enter-start-date-title': 'Angiv startdato',
  'project-fields.project-start-date.open-calendar-label': 'Åbn kalender',
  'project-fields.project-start-date.read-only': 'Kun bidragsydere med redigeringsadgang kan ændre startdatoen.',
  'project-fields.project-start-date.title': 'Startdato',
  'project-fields.project-state.archived': 'Arkiveret',
  'project-fields.project-state.at-risk': 'I farezonen',
  'project-fields.project-state.cancelled': 'Annulleret',
  'project-fields.project-state.completed': 'Afsluttet 🎉',
  'project-fields.project-state.off-track': 'På vildspor',
  'project-fields.project-state.on-track': 'På ret kurs',
  'project-fields.project-state.paused': 'Sat på pause',
  'project-fields.project-state.pending': 'Afventer',
  'project-fields.project-status-picker.project-status-picker-more-button': 'Flere statusser',
  'project-fields.project-status.title': 'Status',
  'project-fields.project-tags.add-tags-title': 'Tilføj tags',
  'project-fields.project-tags.empty-title': 'Ingen tags',
  'project-fields.project-tags.title': 'Tags',
  'project-fields.project-target-date.picker-placeholder': 'Afventer',
  'project-fields.project-target-date.title': 'Måldato',
  'project-fields.project-work-items.show-all-non-final': 'Vis alle',
  'project-fields.project-work-items.show-less-non-final': 'Vis mindre',
  'project-fields.project-work-tracked-picker.cancel-button': 'Gem',
  'project-fields.project-work-tracked-picker.fallback-description':
    'Tilføj et link til det sted, hvor arbejdet for dette projekt spores',
  'project-fields.project-work-tracked-picker.fallback-invalid-url': 'Angiv en gyldig webadresse',
  'project-fields.project-work-tracked-picker.no-recently-viewed-header': 'Søg efter Jira-sager',
  'project-fields.project-work-tracked-picker.no-recently-viewed-result':
    'Søg efter eller tilføj links til steder, hvor du følger arbejdet for dette projekt.',
  'project-fields.project-work-tracked-picker.no-search-result':
    'Prøv at indtaste Jira-sagsnøglen eller URL-adressen igen, eller brug andre ord til søgningen.',
  'project-fields.project-work-tracked-picker.no-search-results-header': 'Vi kunne ikke finde et match',
  'project-fields.project-work-tracked-picker.recently-viewed-title': 'Senest viste',
  'project-fields.project-work-tracked-picker.results-title': 'Resultater',
  'project-fields.project-work-tracked-picker.search-placeholder': 'Søg efter Jira, eller indsæt et link',
  'project-fields.project-work-tracked-picker.sync-form-description':
    'Knyt dette projekt sammen med den valgte Jira-sag, så synkroniseres oplysningerne automatisk.',
  'project-fields.project-work-tracked-picker.sync-form-warning':
    'Bemærk, at alle, der kan se denne Jira-sag, kan se projektoplysningerne.',
  'project-fields.project-work-tracked-picker.sync-with-jira-button': 'Synkroniser med Jira',
  'project-fields.project-work-tracked-picker.sync-with-jira-cancel-button': 'Annuller',
  'project-fields.project-work-tracked-picker.sync-with-jira-connect-button': 'Forbind',
  'project-fields.project-work-tracked-picker.sync-with-jira-detail-selection':
    'Vælg de detaljer, du vil bruge til dette arbejde fremover:',
  'project-fields.project-work-tracked-picker.sync-with-jira-header': 'Synkroniser dette projekt med Jira',
  'project-fields.project-work-tracked-picker.sync-with-jira-label-syncing': 'Synkronisering af mærkater',
  'project-fields.project-work-tracked-picker.sync-with-jira-label-syncing-description':
    'Synkroniser mærkater fra Jira med tags på projektet',
  'project-fields.project-work-tracked-picker.sync-with-jira-project-name': 'Projektnavn',
  'project-fields.project-work-tracked-picker.sync-with-jira-start-date': 'Startdato',
  'project-fields.project-work-tracked-picker.sync-with-jira-target-date': 'Måldato',
  'project-fields.project-work-tracked-picker.sync-with-jira-via-project': '{projectName} {viaProject}',
  'project-fields.project-work-tracked-picker.text-placeholder': 'Link til sporing af arbejde',
  'project-fields.project-work-tracked-picker.work-tracked-picker-content':
    'Søg efter Jira-sager, eller tilføj links til steder, hvor du følger sager til dette projekt.',
  'project-fields.project-work-tracked-picker.work-tracked-picker-title': 'Hvor spores arbejdet?',
  'project-fields.project-work-tracked.add-work-tracked-title': 'Tilføj Jira-sager',
  'project-fields.project-work-tracked.empty-title': 'Ingen Jira-sager',
  'project-fields.project-work-tracked.linked-with-jira-label': 'Knyttet til Jira',
  'project-fields.project-work-tracked.sync-now-label': 'Synkroniser nu',
  'project-fields.project-work-tracked.synced-with-jira-label': 'Synkroniseret med Jira',
  'project-fields.project-work-tracked.title': 'Sag sporet',
  'project-fields.related-project-picker.add-button-label': 'Tilføj',
  'project-fields.related-project-picker.cancel-button-label': 'Annuller',
  'project-fields.related-project-picker.depended-by-option-label': 'Projektet er indbyrdes afhængigt med',
  'project-fields.related-project-picker.depends-on-option-label': 'Projektet er afhængigt af',
  'project-fields.related-project-picker.empty-state-description':
    'Find relaterede projekter, der skal knyttes til dette projekt.',
  'project-fields.related-project-picker.empty-state-title': 'Søg efter projekter',
  'project-fields.related-project-picker.project-relationship-type-label': 'Vælg projektrelationstypen',
  'project-fields.related-project-picker.project-search-placeholder': 'Søg efter projekter',
  'project-fields.related-project-picker.related-option-label': 'Projektet er relateret til',
  'project-fields.related-project-picker.related-project-list-label': 'Relaterede projekter',
  'project-fields.related-projects.add-related-title': 'Tilføj relaterede projekter',
  'project-fields.related-projects.add-related-tooltip': 'Tilføj afhængige eller relaterede projekter',
  'project-fields.related-projects.dependent-by-projects-heading': 'Afhængig af',
  'project-fields.related-projects.dependent-on-projects-heading': 'Afhængig af',
  'project-fields.related-projects.empty-title': 'Ingen relaterede projekter',
  'project-fields.related-projects.related-projects-heading': 'Relateret til',
  'project-fields.related-projects.title': 'Relateret',
  'project-fields.use-project-flags.generic-error-description': 'Der gik noget galt. Prøv igen om et par minutter.',
  'project-fields.use-project-flags.generic-error-title': 'Noget gik galt',
  'project-fields.use-project-flags.project-links-add-failure-title': 'Linket kunne ikke tilføjes',
  'project-fields.use-project-flags.project-links-delete-failure-title': 'Linket kunne ikke fjernes',
  'project-fields.use-project-flags.project-links-edit-failure-title': 'Linket kunne ikke redigeres',
  'project-fields.use-project-flags.project-owner-change-error-header': 'Projektejeren kunne ikke ændres',
  'project-fields.use-project-flags.project-start-date-change-error-header':
    'Vi kunne ikke opdatere projektets startdato',
  'project-fields.use-project-flags.project-tags-add-failure-title': 'Tagget kunne ikke tilføjes',
  'project-fields.use-project-flags.project-tags-create-failure-title': 'Tagget kunne ikke oprettes',
  'project-fields.use-project-flags.project-tags-create-limit-failure-description':
    'Det angivne tagnavn er for langt. Angiv et tagnavn med højst 255 tegn.',
  'project-fields.use-project-flags.project-tags-create-limit-failure-title': 'Tagget kunne ikke oprettes',
  'project-fields.use-project-flags.project-tags-remove-failure-title': 'Tagget kunne ikke fjernes',
  'project-fields.use-project-flags.project-team-remove-failure-description':
    'Der opstod en fejl under fjernelse af teamet. Prøv igen.',
  'project-fields.use-project-flags.related-project-remove-failure-title': 'Det relaterede projekt kunne ikke fjernes',
};
